import type { ButtonOptions } from './button-options.model';

export function translateRadioOption(
  value: any,
  options: ButtonOptions[] | undefined
) {
  return options?.find((option) => option.value === value)?.label?.value;
}
